/* unplugin-vue-components disabled */import { render } from "./markdownRenderer.vue?vue&type=template&id=4b4c21bc"
import script from "./markdownRenderer.vue?vue&type=script&lang=js"
export * from "./markdownRenderer.vue?vue&type=script&lang=js"

import "./markdownRenderer.vue?vue&type=style&index=0&id=4b4c21bc&lang=stylus"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__